import type {SuggestionItems} from '@Components/input-suggestions-dropdown/input-suggestions-dropdown.types';
import {getBusinessProfilesAddressSuggestion, getBusinessProfilesUrlLinkSuggestions, getEventsSuggestions} from '@Components/input-suggestions-dropdown/input-suggestions-library';
import {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {setBusinessAddress, setInputSuggestions} from '@/components/poster-editor/poster-editor-reducer';
import {isUserLoggedIn} from '@Libraries/user.library';
import {PromiseStatus} from '@Utils/ajax.util';

export const useGetLinkInputSuggestions = (): SuggestionItems => {
  const dispatch = useAppDispatch();
  const linkSuggestions = useAppSelector((state) => {
    return state.posterEditor.inputSuggestions;
  });
  const isLoggedIn = isUserLoggedIn();

  useEffect(() => {
    if (isLoggedIn && !linkSuggestions) {
      void getLinkSuggestions();
    }
  }, [isLoggedIn]);

  const getLinkSuggestions = async (): Promise<void> => {
    const [smSuggestions, eventSuggestions] = await Promise.allSettled([
      getBusinessProfilesUrlLinkSuggestions(),
      getEventsSuggestions(),
    ]);

    const fulfilledSmSuggestions = smSuggestions.status === PromiseStatus.FULFILLED ? smSuggestions.value : [];
    const fulfilledEventSuggestions = eventSuggestions.status === PromiseStatus.FULFILLED ? eventSuggestions.value : [];
    dispatch(setInputSuggestions([...fulfilledEventSuggestions, ...fulfilledSmSuggestions]));
  };

  return linkSuggestions ?? [];
};

export const useBusinessAddressSuggestion = (): SuggestionItems => {
  const dispatch = useAppDispatch();
  const addressSuggestion = useAppSelector((state) => {
    return state.posterEditor.businessAddressSuggestions;
  });

  useEffect(() => {
    if (!addressSuggestion) {
      void getBusinessAddress();
    }
  }, []);

  const getBusinessAddress = async (): Promise<void> => {
    const businessAddressSuggestion = await getBusinessProfilesAddressSuggestion();
    dispatch(setBusinessAddress(businessAddressSuggestion));
  };

  return addressSuggestion ?? [];
};
